var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-default btn-with-icon btn-responsible",class:{'is-responsible': _vm.isResponsible },attrs:{"type":"button","disabled":!_vm.user.is_technician || _vm.project.is_completed},on:{"click":function($event){return _vm.setAsReponsible()}}},[_c('i',{staticClass:"fa fa-star"})])
}
var staticRenderFns = []

export { render, staticRenderFns }